<a class="link" target="_blank" rel="noopener" [href]="href"><ng-content></ng-content></a>
